import React from 'react';
import styled from '../../../libs/styled.es.js';

const Wrapper = styled.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ React.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ React.createElement("picture", null, /* @__PURE__ */ React.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ React.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = styled(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ React.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ React.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};

export { LazyImage, WebpImage };
